var getVariantPath = function getVariantPath(_ref) {
  var atomicType = _ref.atomicType,
    componentId = _ref.componentId,
    variantName = _ref.variantName,
    field = _ref.field,
    _ref$additionalKeys = _ref.additionalKeys,
    additionalKeys = _ref$additionalKeys === void 0 ? [] : _ref$additionalKeys;
  var additionalKeysObjectPath = additionalKeys.join('.');
  var isBasePath = !variantName;
  var fieldPath = field ? ".".concat(field) : '';
  if (isBasePath) {
    var basePath = "".concat(atomicType, ".").concat(componentId, ".base").concat(fieldPath).concat(additionalKeysObjectPath);
    return basePath;
  }
  var variantPath = "".concat(atomicType, ".").concat(componentId, ".variants.").concat(variantName).concat(fieldPath).concat(additionalKeysObjectPath);
  return variantPath;
};

export { getVariantPath };
